import { WidgetExternalApplicationType } from '../../../../types/widget';
import ExternalApplicationItem from '../components/ExternalApplicationItem';
import ExternalApplicationForm from '../configuration/ExternalApplicationForm';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';

type MySilaeFormProps = {
	application: WidgetExternalApplicationType;
	isNew: boolean;
	onSubmit: (application: WidgetExternalApplicationType) => void;
	onRemove: (application: WidgetExternalApplicationType) => void;
};

export const MySilaeForm = ({ application, isNew, onSubmit, onRemove }: MySilaeFormProps) => (
	<ExternalApplicationForm application={application} isNew={isNew} onSubmit={onSubmit} onRemove={onRemove} />
);

const MySilae = ({ name }: ExternalApplicationType) => (
	<ExternalApplicationItem name={name} imageSrc="/widgets/images/mySilae-logo.png" />
);

export const getDetails = ({ name }: Pick<ExternalApplicationType, 'name'>): ExternalApplicationDetails => ({
	name,
	url: `https://my.silae.fr/sign-in`,
	component: <MySilae name={name} />,
});
